import React, { useEffect, useRef } from "react";

// --- COMPONENTE SERVICES ---
// Este componente exibe o texto e a imagem do casal
export const Services = (props) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("is-visible");
          observer.unobserve(section);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="serv" ref={sectionRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Aproveite os benefícios que você mais espera e precisa!</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>              
            </div>
          </div>
          <div className="col-xs-12 col-md-6 d-flex">
            <img src="img/team.png" className="img-responsive scale-x" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};


// --- COMPONENTE LDSERVICES ---
// Este componente exibe a grade de serviços (os 12 cards + o card largo)
export const LdServices = ({ data }) => {
  const line1 = data?.line ?? [];
  const line2 = data?.line2 ?? [];
  const line3 = data?.line3 ?? [];
  // Adicionamos a captura da line4 aqui
  const line4 = data?.line4 ?? []; 

  const allItems = [...line1, ...line2, ...line3];

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const rows = chunkArray(allItems, 3);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll("#services .card, #services .card-wide").forEach((card) => {
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, [data]);

  return (
    <div id="services" className="text-center" style={{ paddingBottom: "100px" }}>
      <div className="container">
        <div className="section-title">
          <h2>para você e para sua empresa</h2>
        </div>

        {/* Renderiza as linhas normais de 3 cards (line1, line2, line3) */}
        {rows.length === 0 ? (
          <div className="no-services">Nenhum serviço encontrado</div>
        ) : (
          rows.map((row, rowIndex) => (
            <div key={`row-${rowIndex}`} className="row">
              {row.map((d, i) => {
                const positionClass =
                  i === 0 ? "slide-left" : i === 1 ? "slide-up" : "slide-right";
                const delayClass = `delay-${i}`;
                const key =
                  (d && (d.name || d.id)) || `service-${rowIndex}-${i}`;

                return (
                  <div
                    key={`${key}-${rowIndex}-${i}`}
                    className="col-md-4 col-xs-12"
                  >
                    <div className={`card ${positionClass} ${delayClass}`}>
                      <i className={d.icon}></i>
                      <div className="service-desc">
                        <h3>{d.name}</h3>
                        <p>{d.text}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))
        )}

        {/* --- LINE 4: mesma grade de 3 cards que as linhas acima --- */}
        {line4.length > 0 && (
          <div className="row" style={{ marginTop: "30px" }}>
            {line4.map((d, i) => {
              const positionClass =
                i === 0 ? "slide-left" : i === 1 ? "slide-up" : "slide-right";
              const delayClass = `delay-${Math.min(i, 2)}`;
              const key = (d && (d.name || d.id)) || `line4-${i}`;

              return (
                <div
                  key={`line4-${key}-${i}`}
                  className="col-md-4 col-xs-12"
                >
                  <div className={`card ${positionClass} ${delayClass}`}>
                    <i className={d.icon} aria-hidden="true" />
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </div>
  );
};